<template>
  <div id="masonry">
    <slot>
      <!-- content of masonry -->
    </slot>
  </div>
</template>

<script>
import { Masonry } from '@fristys/masonry'
import GLightbox from 'glightbox'

export default {
  name: 'VMasonry',
  mounted () {
    this.$nextTick(() => {
      // https://fristys.github.io/masonry/
      const options = { gutter: 1.5, gutterUnit: 'rem', columnBreakpoints: { 960: 2, 740: 1 } }
      const masonry = new Masonry(document.getElementById('masonry'), options)
      const lightbox = GLightbox({
        selector: '.glightbox-masonry'
      })
    })
  }
}
</script>
